import React from 'react';
import _ from 'lodash';
import { Box, Drawer, Tooltip, Fab, List, Stack, Checkbox, Typography } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { DebounceInput } from 'react-debounce-input';

import { useResponsive } from '../../../../services/hooks';
import { NAVBAR } from '../../../../utils/config';
import { getPromotionPredefinedFilters } from '../../../../services/request';
import { FilterTree } from './promotion-details/FilterTree';
import Scrollbar from '../../../../components/Scrollbar';
import { CssTextField } from '../../../../components/others/CssTextField';

export const PromotionSidebar = props => {
  const { isOpenSidebar, onCloseSidebar, createSignal, queryCallback } = props;
  const { season } = useSelector(state => state.app);
  const filtersRef = React.useRef();
  const predefinedFilters = useQuery(getPromotionPredefinedFilters(season, 'Filtry Wycieczek'));
  const isDesktop = useResponsive('up', 'md');
  const [treeObjects, setTreeObjects] = React.useState({});
  const [name, setName] = React.useState('');
  const [isEnabled, setIsEnabled] = React.useState(null);
  const [bigFamilyCardConnected, setBigFamilyCardConnected] = React.useState(null);

  React.useEffect(() => {
    if (!predefinedFilters.error && !predefinedFilters.loading) {
      setTreeObjects(predefinedFilters.payload);
    }
  }, [season, predefinedFilters.loading]);

  React.useEffect(() => {
    if (filtersRef && filtersRef.current) {
      let search = '';
      if (filtersRef.current.getTree() !== 'tree=') {
        search += `tree=${filtersRef.current.getTree()}&`;
      }
      if (!_.isEmpty(name)) {
        search += `name=${name}&`;
      }
      if (isEnabled !== null) {
        search += `is_enabled=${isEnabled}&`;
      }
      if (bigFamilyCardConnected !== null) {
        search += `is_connected_with_big_family_card=${bigFamilyCardConnected}&`;
      }
      queryCallback(search);
    }
  }, [name, isEnabled, bigFamilyCardConnected]);

  const filterCallback = selectedTree => {
    let search = '';
    if (selectedTree !== 'tree=') {
      search += selectedTree;
    }
    if (!_.isEmpty(name)) {
      search += `name=${name}&`;
    }
    if (isEnabled !== null) {
      search += `is_enabled=${isEnabled}&`;
    }
    if (bigFamilyCardConnected !== null) {
      search += `is_connected_with_big_family_card=${bigFamilyCardConnected}&`;
    }
    queryCallback(search);
  };

  const renderContent = (
    <Scrollbar sx={{ opacity: predefinedFilters.loading ? '0.5' : '1' }}>

      <Box sx={{ p: 1 }}>
        <Box display="flex" justifyContent="center">
          <Tooltip title="Dodaj promocję" sx={{ mb: 4 }}>
            <Fab
              color="primary"
              aria-label="add"
              onClick={() => {
                createSignal();
              }}
            >
              <AddIcon style={{ fontSize: '30px' }} />
            </Fab>
          </Tooltip>
        </Box>
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Nazwa promocji..."
          onChange={e => setName(e.target.value)
          }
          variant="standard"
        />
        <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%" sx={{ mb: 2 }}>
          <Checkbox
            checked={isEnabled}
            indeterminate={isEnabled === false}
            onChange={() => setIsEnabled(isEnabled === true ? false : isEnabled === false ? null : true)}/>
          <Typography>Aktywna</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%" sx={{ mb: 2 }}>
          <Checkbox
            checked={bigFamilyCardConnected}
            indeterminate={bigFamilyCardConnected === false}
            onChange={() => setBigFamilyCardConnected(bigFamilyCardConnected === true ? false : bigFamilyCardConnected === false ? null : true)}/>
          <Typography>Poł z kartą d. rodziny</Typography>
        </Stack>
        <List disablePadding>
          {!_.isEmpty(treeObjects)
            ? <FilterTree data={treeObjects} ref={filtersRef} initSelected={[]} filterCallback={filterCallback} />
            : null
          }
        </List>
      </Box>
    </Scrollbar>
  );

  return (
    <>
      {isDesktop ? (
        <Drawer variant="permanent" PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH + 20, position: 'relative' } }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}
    </>
  );
};
